import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
const testimonials = [{
  quote: 'Nimbusquest replaced four separate tools for us. Our onboarding workflow went from 3 hours to 12 minutes.',
  name: 'Elowen Marchetti',
  role: 'Head of Operations',
  company: 'Verdano',
  initials: 'EM'
}, {
  quote: 'The Cascade Builder is genuinely intuitive. Our non-technical team members build their own automations now.',
  name: 'Caspian Voss',
  role: 'CTO',
  company: 'Lumencraft',
  initials: 'CV'
}, {
  quote: 'We process 40,000 tasks monthly without a single manual intervention. Nimbusquest just works.',
  name: 'Isolde Katsaros',
  role: 'Founder',
  company: 'Pelagos Digital',
  initials: 'IK'
}];
export function TestimonialsSection() {
  return <section id="testimonials" className="py-24 bg-white" data-id="element-199">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-200">
        <div className="text-center mb-16" data-id="element-201">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4" data-id="element-202">
            Trusted by Ambitious Teams
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-203">
          {testimonials.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-slate-50 p-8 rounded-2xl relative" data-id="element-204">
              <Quote className="text-sky-200 w-10 h-10 absolute top-6 left-6 -z-0" data-id="element-205" />

              <p className="text-slate-700 text-lg italic mb-8 relative z-10 pt-4" data-id="element-206">
                "{item.quote}"
              </p>

              <div className="flex items-center gap-4" data-id="element-207">
                <div className="w-12 h-12 rounded-full bg-sky-100 flex items-center justify-center text-sky-600 font-bold text-lg" data-id="element-208">
                  {item.initials}
                </div>
                <div data-id="element-209">
                  <h4 className="font-bold text-slate-900" data-id="element-210">{item.name}</h4>
                  <p className="text-sm text-slate-500" data-id="element-211">
                    {item.role} at {item.company}
                  </p>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}